import { FeatureDTO } from "./FeatureDTO";

export class StorageFeatureDTO extends FeatureDTO {
    constructor(sub?) {
        super(sub);
    }
}
